"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContext = exports.FieldContext = void 0;
Object.defineProperty(exports, "ValidationTypes", {
  enumerable: true,
  get: function get() {
    return _types.HintTypes;
  }
});
var _types = require("../Hint/types");
var FormContext;
exports.FormContext = FormContext;
(function (FormContext) {
  var Types;
  (function (Types) {
    Types["Create"] = "create";
    Types["Update"] = "update";
  })(Types = FormContext.Types || (FormContext.Types = {}));
  var ReducerActionTypes;
  (function (ReducerActionTypes) {
    ReducerActionTypes["AddAdditionalInputProp"] = "ADD_INITIAL_INPUT_PROP";
    ReducerActionTypes["AddFieldValidation"] = "ADD_FIELD_VALIDATION";
    ReducerActionTypes["AddFormValidation"] = "ADD_FORM_VALIDATION";
    ReducerActionTypes["AddValidationMessages"] = "ADD_VALIDATION_MESSAGES";
    ReducerActionTypes["ClearAllValidationMessages"] = "CLEAR_ALL_VALIDATION_MESSAGES";
    ReducerActionTypes["ClearValidationMessages"] = "CLEAR_VALIDATION_MESSAGES";
    ReducerActionTypes["InitializeFormDataField"] = "INITIALIZE_FORM_DATA_FIELD";
    ReducerActionTypes["RemoveFieldValidation"] = "REMOVE_FIELD_VALIDATION";
    ReducerActionTypes["RemoveFormValidation"] = "REMOVE_FORM_VALIDATION";
    ReducerActionTypes["ResetFieldRequiresValidation"] = "RESET_FIELD_REQUIRES_VALIDATION";
    ReducerActionTypes["SetFormData"] = "SET_FORM_DATA";
    ReducerActionTypes["SetFormDataFieldValue"] = "SET_FORM_DATA_FIELD_VALUE";
    ReducerActionTypes["SetIsCanceling"] = "SET_IS_CANCELING";
    ReducerActionTypes["SetIsDeleting"] = "SET_IS_DELETING";
    ReducerActionTypes["SetIsSubmitting"] = "SET_IS_SUBMITTING";
    ReducerActionTypes["TerminateFormDataField"] = "TERMINATE_FORM_DATA_FIELD";
  })(ReducerActionTypes = FormContext.ReducerActionTypes || (FormContext.ReducerActionTypes = {}));
})(FormContext || (exports.FormContext = FormContext = {}));
var FieldContext;
exports.FieldContext = FieldContext;
(function (FieldContext) {
  var ReducerActionTypes;
  (function (ReducerActionTypes) {
    ReducerActionTypes["SetFieldName"] = "SET_FIELD_NAME";
    ReducerActionTypes["SetIsRequired"] = "SET_IS_REQUIRED";
    ReducerActionTypes["SetShowDefaultLabel"] = "SET_SHOW_DEFAULT_LABEL";
    ReducerActionTypes["SetValidateOnChange"] = "SET_VALIDATE_ON_CHANGE";
  })(ReducerActionTypes = FieldContext.ReducerActionTypes || (FieldContext.ReducerActionTypes = {}));
})(FieldContext || (exports.FieldContext = FieldContext = {}));